// extracted by mini-css-extract-plugin
module.exports = {"avatar":"ProfileModal_avatar__1kgVd","close":"ProfileModal_close__I98GQ"};